/** Progress / achievement heatmap: aligns with backend score-model copy */
export function progressHeatColor(percent) {
  const p = Math.min(100, Math.max(0, Number(percent) || 0));
  if (p < 50) return { bg: '#ffebee', fg: '#c62828', label: 'At risk' };
  if (p < 80) return { bg: '#fff8e1', fg: '#f57f17', label: 'Needs attention' };
  if (p < 100) return { bg: '#e8f5e9', fg: '#2e7d32', label: 'On track' };
  return { bg: '#c8e6c9', fg: '#1b5e20', label: 'Complete' };
}

/** Key Results category portfolio bar color from weight share (design accent, not health) */
export function categoryBarColor(index) {
  const palette = ['#6366f1', '#8b5cf6', '#ec4899', '#14b8a6', '#f59e0b', '#3b82f6', '#ef4444', '#84cc16'];
  return palette[index % palette.length];
}
